import { Navigate, useLocation } from "react-router-dom";
import { Label } from "@/components/ui/label";
import { useMe } from "@/hooks/useMe";

export const Eyebrow = ({ children, light }) => (
  <div className={`text-xs font-bold uppercase tracking-[0.18em] ${light ? "text-orange-400" : "text-orange-600"}`}>{children}</div>
);

export const PageTitle = ({ eyebrow, title, sub, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4">
    <div>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h1 className="mt-2 font-heading text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">{title}</h1>
      {sub && <p className="mt-2 text-slate-600">{sub}</p>}
    </div>
    {children}
  </div>
);

export const Field = ({ label, children }) => (
  <div className="space-y-1.5"><Label className="text-sm font-semibold text-slate-700">{label}</Label>{children}</div>
);

export const Loading = () => <div className="h-64 animate-pulse rounded-3xl bg-slate-200" data-testid="loading" />;

export const ErrorBox = ({ text = "No se pudieron cargar los datos de la app HandyZoom. Inténtalo de nuevo en unos minutos." }) => (
  <div data-testid="error-box" className="rounded-2xl border border-rose-200 bg-rose-50 p-5 text-sm text-rose-800">{text}</div>
);

export const Empty = ({ children }) => (
  <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-8 text-center text-sm text-slate-500">{children}</div>
);

export const RequireAuth = ({ role, children }) => {
  const { data: me, isLoading } = useMe();
  const loc = useLocation();
  if (isLoading) return <div className="mx-auto max-w-6xl px-4 py-10"><Loading /></div>;
  if (!me) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (role && me.role !== role) return <Navigate to="/panel" replace />;
  return children;
};

export const Page = ({ children, className = "" }) => <div className={`mx-auto max-w-6xl px-4 py-10 md:py-14 ${className}`}>{children}</div>;
